import { Fragment, useEffect, useState } from "react";
import { Text } from "../../FormControls/Text";
import { jump } from "../../../../main/slices/routerSlice";
import { Box } from "../../FormControls/Box";
import { Stack } from "../../FormControls/Stack";
import { ArrowForwardIos, MarkEmailRead, PointOfSaleRounded } from "@mui/icons-material";
import {
  setAccountCurrency,
} from "../../../../main/slices/bankSlice";
import { ScreenControl } from "../ScreenControl";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { AlertSelectBox } from "../../FormControls/SelectAlert";
import { LoadingComponent } from "../../LoadingComponent";
import {
  setCountry,
  setIpData
} from "../../../../main/slices/userSlice";
import {
  setPos,
  setGroup,
  setStoreName,
  setCountrySrore,
  setCurrencyStore,
  setIdStore,
  setMasterUser,
  loginStoreAuto,
} from "../../../../main/slices/storeSlice";

const GetIPAddress = async () => {
  try {
    const response = await fetch(
      "https://ipapi.co/json" //---> No exponer nuestro SRV;
    );

    const data = await response.json();

    return data; // Devuelve solo el país
  } catch (error) {
    console.error("Error al obtener los detalles de la IP:", error);
    return null;
  }
};

export default GetIPAddress;

export const SelectLogin = () => {
  const dispatch = useDispatch();
  const state = useSelector(({ user }) => user);
  const [cookies, setCookies, removeCookie] = useCookies(["procedure"]);
  //AUTO LOGIN
  const [autoLogin, setAutoLogin] = useState(true);

  // ALERT
  const [showAlert, setShowAlert] = useState(false); // view alert
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success');

  // ALERT OPTIONS
  const handleCloseAlert = () => {
    setCookies("closeSesion", true);
    setShowAlert(false)
  };

  const handleConfirmAlert = () => {
    //MUESTRO EL PAD
    dispatch(jump({ current: 8, direction: "forward" }))
    setShowAlert(false)
  };

  //---> Según las configuraciones que opciones de retiro en efectivo se deben mostrar;
  let bank = JSON.parse(process.env.REACT_APP_MOSTRAR_RETIRO_BANCARIO);
  let cash = JSON.parse(process.env.REACT_APP_MOSTRAR_RETIRO_EFECTIVO); //&&state.country.value.substr(-2)=="GT";
  let coupons = JSON.parse(process.env.REACT_APP_MOSTRAR_RETIRO_CUPONES);
  let cash5B = JSON.parse(process.env.REACT_APP_MOSTRAR_RETIRO_EFECTIVO_5B);
  let cashStore = JSON.parse(
    process.env.REACT_APP_MOSTRAR_RETIRO_EFECTIVO_KIOSCOS
  );
  let cashNextStep = 1;
  let cashLabel = "Recibe efectivo en cajeros, tiendas o kioscos";
  let cashType = "FIAT";

  //---> Si debo mostrar el btn para que pueda seleccionar una de las opciones;
  if (cash) {
    if (cash5B && cashStore) {
      /* no hago nada, es el predeterminado */
    } else if (cash5B) {
      cashType = "FIAT:5B";
      cashNextStep = 2;
      cashLabel = "Recibe efectivo desde cajeros 5B";
    } else if (cashStore) {
      cashType = "FIAT:CASH";
      cashNextStep = 2;
      cashLabel = "Recibe efectivo desde kioscos o Tiendas";
    }
  }

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.6)", // fondo semitransparente
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  };

  const spinnerContainer = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const getAutoLogin = async () => {
      return await dispatch(loginStoreAuto({
        "origin": "worldpos",
        "wldId": state.idWLD,
      }))
        .unwrap()
        .then(async ({ response }) => {
          if (response.code===200) {
            // setCookies("login", "pad");
            let group= response.data.group;
            let pos= response.data.pos;
            let id= response.data.id;
            let name= response.data.name;
            let currency= response.data.currency;
            let country= response.data.country;
            let isMaster= response.data.master;
  
            //SETO LOS DATOS DE LA TIENDA
            dispatch(setPos({ value: pos, error: false }));
            dispatch(setMasterUser({ value: isMaster, error: false }));
            dispatch(setIdStore({ value: id, error: false }));
            dispatch(setGroup({value: group, error: false }));
            dispatch(setStoreName({ value: name, error: false }));
            dispatch(setCountrySrore({value: country, error: false }));
            dispatch(setCurrencyStore({ value: currency, error: false }));
            
            //MUESTRO LA ALERTA DE SESION
            setAlertType('error');
            setAlertMessage(`Deseas iniciar sesión con tu ultimo comercio: (${name}) utilizado.`);
            setShowAlert(true);

          }
          setAutoLogin(false)
        })
        .catch(e => {
          setAutoLogin(false)
        });
  }

  const handleProcedure = (type) => {
    // removeCookie("procedure", type, { path: "/" });
    setCookies("procedure", type, { path: "/" });
    setCookies("registerFromList", false, { path: "/" });
    if (type === "register") {
      dispatch(jump({ current: 2, direction: "forward", }));
    }

    return true;
  };

  // Función para manejar el cambio de país
  const handleCountry = (value) => {
    dispatch(setCountry({ value, error: !value }));
  };

  // Función para manejar el cambio de moneda
  const handleCurrency = (value) => {
    dispatch(setAccountCurrency({ value, error: !value }));
  };

  useEffect(() => {
    // document.body.style.overflow = 'hidden';
    const setCountryFromIP = async () => {
      const infoData = await GetIPAddress();
      if (infoData) {
        dispatch(setIpData({value: infoData}))  
        handleCountry(infoData.country); // Actualiza el estado con el país obtenido
        handleCurrency(infoData.currency);
      } else {
        handleCountry(""); // Manejo de error si no se obtiene un país
      }
    };
    getAutoLogin();
    if (!state.country.value) setCountryFromIP();
  }, [setCookies]);

  return (
    <Fragment>

      {/* SELECT ALERT */}
      {(showAlert && cookies.closeSesion===false) && (
        <AlertSelectBox
          message={`${alertMessage}`}
          type={alertType}
          titulo={"Iniciar Sesión"}
          onCancel={handleCloseAlert}
          onConfirm={handleConfirmAlert}
        />
      )}

      {/* ICONO DE CARGA */}
      {autoLogin &&  cookies.closeSesion===false && (
        <div style={overlayStyle}>
          <div style={spinnerContainer}>
            <LoadingComponent />
            <p style={{ color: "white", marginTop: 10 }}>Cargando datos...</p>
          </div>
        </div>
      )}
      <div style={{ padding: "0 1.5rem" }}>
        <Stack flex={{ flexDirection: "column" }}>
          <Text classes={["title", "center"]}> ¡Cobra tus productos con la app Recibe! </Text>
        </Stack>
        <div style={{ marginBottom: "1rem" }}></div>
        <Stack flex={{ flexDirection: "column" }}>
          {/* CALL TO ACTION */}
          <Text classes={["subtitle"]}> ¿Cómo deseas iniciar sesión? </Text>

          {/* CASH WITHDRAWAL */}
          {state.country.value == "GT" && cash && (
            <ScreenControl
              index={{ fw: 1 }}
              disabled={false}
              parentClasses={["cardOption", "marginTB1em"]}
              onclick={() => {
                setCookies("procedure", "auth", { path: "/" });
              }}
            >
              <Stack flex={{ flexDirection: "row", alignItems: "center" }}>
                <Box superStyle={{ width: "20%" }}>
                  <Text classes={["left"]}>
                    <PointOfSaleRounded></PointOfSaleRounded>
                  </Text>
                </Box>
                <Box>
                  <Text classes={["mediumText"]}>Ingresar Pos</Text>
                  <Text classes={["annotation"]}>{"Accede directamente a tu comercio"}</Text>
                </Box>
                <Box superStyle={{ width: "20%" }}>
                  <Text classes={["right"]}>
                    <ArrowForwardIos></ArrowForwardIos>
                  </Text>
                </Box>
              </Stack>
            </ScreenControl>
          )}

          {/* BANK WITHDRAWAL */}
          {bank && (
            <ScreenControl
              index={{ fw: 2 }}
              disabled={false}
              parentClasses={["cardOption", "marginTB1em"]}
              beforeSubmit={() => handleProcedure("login")}
            >
              <Stack flex={{ flexDirection: "row", alignItems: "center" }}>
                <Box superStyle={{ width: "20%" }}>
                  <Text classes={["left"]}>
                    <MarkEmailRead></MarkEmailRead>
                  </Text>
                </Box>
                <Box>
                  <Text classes={["mediumText"]}>Ingresar Correo{" "}</Text>
                  <Text classes={["annotation"]}>{"Ve la lista de comercios y elecciona tu favorito"}</Text>
                </Box>
                <Box superStyle={{ width: "20%" }}>
                  <Text classes={["right"]}>
                    <ArrowForwardIos></ArrowForwardIos>
                  </Text>
                </Box>
              </Stack>
            </ScreenControl>
          )}
          <div style={{ marginBottom: "5rem" }}></div>
          <Text
            classes={["center", "subtitle", "description"]}
            style={{
              margin: 0,
              padding: 0,
              display: "inline",
            }}
          >
            ¿Aún no tienes un comercio registrado?
          </Text>
        </Stack>
        <ScreenControl 
          showGoBack={false}
          btncolor={"registerBtn"}
          btnText={"Crear Cuenta"}
          index={{fw: 2 }}
          beforeSubmit={() => handleProcedure("register")}
          disabled={false} 
        />
      </div>
    </Fragment>
  );
};
